<template class='body-section'>
  <v-row class="justify-center">
        <v-card elevation=0 color='transparent' class="justify-center">
          <v-img
          class="mt-12 mx-auto"
          src="/ext_files/prepaid/q/media/koneLogo-orange.png"
          max-width="350"
        />
        <div class="blue-title text-center mx-auto">
            {{getMessages['raf.requirements.tryagain']}}
            <!-- Για να συνεχίσεις ακολούθησε τα παρακάτω βήματα και δοκίμασε ξανά -->
        </div>
        <v-card color='#FFF9F0' rounded='xl' class="pa-12" elevation='0'>
          <div class="orange-text">
            <strong>{{getMessages['raf.requirements.youshould']}}</strong>
            <!-- Θα πρέπει: -->
          </div>
           <div v-for="requirement in requirements" :key="requirement" class='py-2'>
            <img src="/ext_files/prepaid/q/media/ul-check.png"> {{requirement}}
          </div>
        </v-card>
        <v-row class="mt-5 mx-auto justify-center text-center">
          <v-col class="shrink">
            <v-btn :href="'/'+$store.getters.getLocale+'/myq/'" large class="white--text px-5" color="#F54D23" rounded>{{getMessages['raf.requirements.close']}}</v-btn>
            <!-- Κλεισιμο -->
          </v-col>
        </v-row>
    </v-card>
  </v-row>
</template>

<script>
export default {
  name: 'Requirements',
  data () {
    return {
      requirements: [
        'Να είσαι ενεργός πελάτης Q στα συστήματα της Εταιρείας πάνω από 30 ημέρες',
        'Να έχεις κάνει ανανέωση χρόνου ομιλίας αξίας 10€ τις τελευταίες 30 ημέρες​',
        'Να έχεις υπόλοιπο πάνω από 0,01€​'
      ]
    }
  },
  watch: {
    requirementsArray (newValue) {
      this.requirements = newValue
    }
  },
  computed: {
    requirementsArray () {
      return this.$store.getters.getNotEligibleUserMessages
    },
    getMessages () {
      return this.$store.getters.getMessages
    }
  },
  methods: {

  },
  async mounted () {
  }
}
</script>

<style>

</style>
